import { Typography } from "@mui/material";

const FormLabel = (props) => (
  // for form labels
  <Typography
    variant="subtitle2"
    sx={{ marginBottom: "5px", ...props.sx }}
  >
    {props.title}
  </Typography>
);

export default FormLabel;
